import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useSportContent } from '../hooks/useSportContent';

const EquipmentScreen: React.FC = () => {
  const { currentSport } = useTheme();
  const { content, loading, error } = useSportContent(currentSport.id);

  if (loading) {
    return (
      <div className="equipment-screen">
        <div className="container">
          <h1>Loading {currentSport.name} Equipment Guide...</h1>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="equipment-screen">
        <div className="container">
          <h1>Error Loading Equipment Guide</h1>
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="equipment-screen">
      <div className="container">
        <h1>{currentSport.name} Equipment Guide</h1>
        <div className="equipment-grid">
          {content?.equipment.map((item) => (
            <div key={item.id} className="equipment-card">
              <h3>{item.name}</h3>
              <p>{item.description}</p>
              <div className="equipment-meta">
                <span className="category">{item.category}</span>
                <span className="price-range">{item.priceRange}</span>
              </div>
              <div className="recommendations">
                <strong>Recommendations:</strong>
                <ul>
                  {item.recommendations.map((rec, index) => (
                    <li key={index}>{rec}</li>
                  ))}
                </ul>
              </div>
              {item.brands && (
                <div className="brands">
                  <strong>Popular Brands:</strong>
                  <span>{item.brands.join(', ')}</span>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EquipmentScreen;
